var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3569_21472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.717 165C124.716 165 160.385 161.065 160.385 156.211C160.385 151.356 124.716 147.421 80.717 147.421C36.7177 147.421 1.04932 151.356 1.04932 156.211C1.04932 161.065 36.7177 165 80.717 165Z",
    fill: "#D1EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.385 8.85812V102.887C160.385 107.198 156.898 110.693 152.598 110.693H8.83491C4.5357 110.693 1.04932 107.198 1.04932 102.887V8.06431C1.04932 4.19204 4.18034 1.05186 8.04446 1.05186H152.598C156.695 1.05186 160.053 4.22429 160.362 8.25364V8.25785C160.378 8.4556 160.385 8.65616 160.385 8.85812Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.385 8.85812V102.887C160.385 107.198 156.898 110.693 152.598 110.693H8.83491C4.5357 110.693 1.04932 107.198 1.04932 102.888V8.06432L7.36733 100.432C7.46806 101.909 8.69221 103.055 10.1696 103.055H151.255C152.731 103.055 153.956 101.909 154.057 100.432L160.364 8.25786C160.379 8.45561 160.386 8.65617 160.386 8.85812H160.385Z",
    fill: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.385 8.85812V102.887C160.385 107.198 156.898 110.693 152.598 110.693H8.83491C4.5357 110.693 1.04932 107.198 1.04932 102.887V8.06431C1.04932 4.19204 4.18034 1.05186 8.04446 1.05186H152.598C156.695 1.05186 160.053 4.22429 160.362 8.25364V8.25785C160.378 8.4556 160.385 8.65616 160.385 8.85812Z",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4123 100.91C102.782 100.91 120.105 83.5442 120.105 62.1219C120.105 40.6995 102.782 23.3332 81.4123 23.3332C60.0428 23.3332 42.7194 40.6995 42.7194 62.1219C42.7194 83.5442 60.0428 100.91 81.4123 100.91Z",
    fill: "#D1EDFF",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4122 27.026C100.747 27.026 116.422 42.7395 116.422 62.1219",
    stroke: "white",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4122 89.9528C96.7449 89.9528 109.175 77.4925 109.175 62.1218C109.175 46.7512 96.7449 34.2908 81.4122 34.2908C66.0795 34.2908 53.6499 46.7512 53.6499 62.1218C53.6499 77.4925 66.0795 89.9528 81.4122 89.9528Z",
    fill: "white",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7566 15.6629H160.385",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6062 20.2071C23.1096 20.2071 25.1391 18.1727 25.1391 15.663C25.1391 13.1534 23.1096 11.119 20.6062 11.119C18.1028 11.119 16.0734 13.1534 16.0734 15.663C16.0734 18.1727 18.1028 20.2071 20.6062 20.2071Z",
    fill: "#D1EDFF",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2666 20.2071C37.77 20.2071 39.7995 18.1727 39.7995 15.663C39.7995 13.1534 37.77 11.119 35.2666 11.119C32.7632 11.119 30.7338 13.1534 30.7338 15.663C30.7338 18.1727 32.7632 20.2071 35.2666 20.2071Z",
    fill: "#D1EDFF",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9271 20.2071C52.4306 20.2071 54.46 18.1727 54.46 15.663C54.46 13.1534 52.4306 11.119 49.9271 11.119C47.4237 11.119 45.3943 13.1534 45.3943 15.663C45.3943 18.1727 47.4237 20.2071 49.9271 20.2071Z",
    fill: "#D1EDFF",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.877 132.74L126.097 96.8712C123.33 94.0976 118.844 94.0974 116.078 96.8707C113.311 99.644 113.312 104.141 116.078 106.914L151.859 142.783C154.626 145.557 159.111 145.557 161.878 142.784C164.644 140.011 164.644 135.514 161.877 132.74Z",
    fill: "white",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.169 129.023L129.804 100.588L119.786 110.631L148.151 139.066L158.169 129.023Z",
    fill: "#D1EDFF",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.773 89.5489L116.077 96.8713",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3636 46.0327L97.4616 78.21",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3636 78.21L97.4616 46.0327",
    stroke: "#35B2FF",
    strokeWidth: 2.49898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3569_21472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 165,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/no_data_found.52632201800d3e855cc2d170fdb74202.svg";
export { ForwardRef as ReactComponent };